import { createPortal } from 'react-dom';
import { Dispatch, MutableRefObject, SetStateAction, useRef, useState } from 'react';
import bg1 from '../assets/background/bg-inquiry-popup.jpg';
import icon1 from '../assets/icon/cloese-icon.svg';

import './popup.scss';
import { useTranslation } from 'react-i18next';
import translateSetting from 'src/core/translate-setting';

const Popup = ({
  setInquiryPopup,
  inquiryPopup,
  setBrochurePopup,
  brochurePopup,
  setPrivatePopup,
  privatePopup,
}: {
  setInquiryPopup: Dispatch<SetStateAction<boolean>>;
  inquiryPopup: boolean;
  setBrochurePopup: Dispatch<SetStateAction<boolean>>;
  brochurePopup: boolean;
  setPrivatePopup: Dispatch<SetStateAction<boolean>>;
  privatePopup: boolean;
}) => {
  return createPortal(
    <div className="Popup">
      {inquiryPopup && <InquiryPopup setInquiryPopup={setInquiryPopup} />}
      {brochurePopup && <BrochurePopup setBrochurePopup={setBrochurePopup} setPrivatePopup={setPrivatePopup} />}
      {privatePopup && <PrivatePopup setPrivatePopup={setPrivatePopup} />}
    </div>,
    document.body
  );
};

const InquiryPopup = ({ setInquiryPopup }: { setInquiryPopup: Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();
  let country = '한국어';
  let category = 'Industry - PRIME 서비스 문의';
  let tab = 'Industry Inquiry';
  let emailSubject = 'PRIME 랜딩페이지로부터 새로운 문의가 접수되었습니다.';
  let emailFooter = '- PRIME 랜딩페이지 문의 -';

  if (curLng === 'ENG') {
    country = '영어';
  }
  if (curLng === 'JPN') {
    country = '일본어';
  }

  let company: MutableRefObject<string> = useRef('');
  let name: MutableRefObject<string> = useRef('');
  let position: MutableRefObject<string> = useRef('');
  let phone: MutableRefObject<string> = useRef('');
  let email: MutableRefObject<string> = useRef('');
  let msg: MutableRefObject<string> = useRef('');
  let path: MutableRefObject<string> = useRef('');

  let [alertCompany, setAlertCompany] = useState(false);
  let [alertName, setAlertName] = useState(false);
  let [alertPhone, setAlertPhone] = useState(false);
  let [alertEmail, setAlertEmail] = useState(false);
  let [alertMsg, setAlertMsg] = useState(false);
  let [alertPath, setAlertPath] = useState(false);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.id == 'company') {
      company.current = e.target.value;

      if (e.target.value == '' || e.target.value == undefined) {
        setAlertCompany(true);
      } else {
        setAlertCompany(false);
      }
    } else if (e.target.id == 'name') {
      name.current = e.target.value;
      if (e.target.value == '' || e.target.value == undefined) {
        setAlertName(true);
      } else {
        setAlertName(false);
      }
    } else if (e.target.id == 'position') {
      position.current = e.target.value;
    } else if (e.target.id == 'phone') {
      phone.current = e.target.value;
      if (e.target.value == '' || e.target.value == undefined) {
        setAlertPhone(true);
      } else {
        setAlertPhone(false);
      }
    } else if (e.target.id == 'email') {
      email.current = e.target.value;
      let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

      if (!regex.test(email.current)) {
        setAlertEmail(true);
      } else {
        setAlertEmail(false);
      }
    } else if (e.target.id == 'msg') {
      msg.current = e.target.value;
      if (e.target.value == '' || e.target.value == undefined) {
        setAlertMsg(true);
      } else {
        setAlertMsg(false);
      }
    } else if (e.target.id == 'path') {
      path.current = e.target.value;
      if (e.target.value == '' || e.target.value == undefined) {
        setAlertPath(true);
      } else {
        setAlertPath(false);
      }
    }
  }

  function handleSubmit() {
    let complete = true;
    let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-z]{2,6}$/;

    if (company.current == '' || company.current == undefined) {
      setAlertCompany(true);
      complete = false;
    }
    if (name.current == '' || name.current == undefined) {
      setAlertName(true);
      complete = false;
    }
    if (phone.current == '' || phone.current == undefined) {
      setAlertPhone(true);
      complete = false;
    }

    if (!regex.test(email.current)) {
      setAlertEmail(true);
      complete = false;
    }
    if (msg.current == '' || msg.current == undefined) {
      setAlertMsg(true);
      complete = false;
    }
    if (path.current == '' || path.current == undefined) {
      setAlertPath(true);
      complete = false;
    }

    if (complete) {
      sendRequest({
        country: country,
        category: category,
        company: company.current,
        name: name.current,
        position: position.current,
        phone: phone.current,
        email: email.current,
        msg: msg.current,
        path: path.current,
        tab,
        emailSubject,
        emailFooter,
      });
      window.alert(t('popup.inquiry.alert-text-1'));
      setInquiryPopup(false);
    } else {
      setInquiryPopup(true);
    }
  }

  async function sendRequest(obj: object) {
    const response = await fetch('https://ruyvdtlqki.execute-api.ap-northeast-2.amazonaws.com/contact', {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'content-Type': 'application/json',
      },
    });
    const data = await response.json();
    console.log(data);
  }

  return (
    <div className="inquiry-popup">
      <div className="content-box">
        <img
          className="close-btn"
          src={icon1}
          onClick={() => {
            setInquiryPopup(false);
          }}
        />
        <div className="left-section">
          <img className="image" src={bg1} />
        </div>
        <div className="right-section">
          <div className="top-section">
            <div className="big-text">{t('popup.inquiry.title-text-0')}</div>
            <div className="middle-text">{t('popup.inquiry.title-text-1')}</div>
            <div className="small-text">{t('popup.inquiry.title-text-2')}</div>
            <div className="small-text">{t('popup.inquiry.title-text-3')}</div>
          </div>
          <form className="bottom-section">
            <div className="category-box">
              <input
                id="company"
                type="string"
                placeholder={t('popup.inquiry.input-text-0')}
                onChange={handleChange}
              ></input>
              {alertCompany && <div className="alert-text">{t('popup.inquiry.alert-text-0')}</div>}
              <input
                id="name"
                type="string"
                placeholder={t('popup.inquiry.input-text-1')}
                onChange={handleChange}
              ></input>
              {alertName && <div className="alert-text">{t('popup.inquiry.alert-text-0')}</div>}
              <input
                id="position"
                type="string"
                placeholder={t('popup.inquiry.input-text-2')}
                onChange={handleChange}
              ></input>
              <input
                id="phone"
                type="string"
                placeholder={t('popup.inquiry.input-text-3')}
                onChange={handleChange}
              ></input>
              {alertPhone && <div className="alert-text">{t('popup.inquiry.alert-text-0')}</div>}
              <input
                id="email"
                type="string"
                placeholder={t('popup.inquiry.input-text-4')}
                onChange={handleChange}
              ></input>
              {alertEmail && <div className="alert-text">{t('popup.inquiry.alert-text-2')}</div>}
              <input
                id="msg"
                type="string"
                placeholder={t('popup.inquiry.input-text-5')}
                onChange={handleChange}
              ></input>
              {alertMsg && <div className="alert-text">{t('popup.inquiry.alert-text-0')}</div>}
              <div className="label-text">{t('popup.inquiry.input-text-6')}</div>
              <input
                id="path"
                className="small-text"
                type="string"
                placeholder={t('popup.inquiry.input-text-7')}
                onChange={handleChange}
              ></input>
              {alertPath && <div className="alert-text">{t('popup.inquiry.alert-text-0')}</div>}
            </div>
            <div className="submit-btn" onClick={handleSubmit}>
              {t('popup.inquiry.btn-text-0')}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const BrochurePopup = ({
  setBrochurePopup,
  setPrivatePopup,
}: {
  setBrochurePopup: Dispatch<SetStateAction<boolean>>;
  setPrivatePopup: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();
  let country = '한국어';
  let category = 'Industry - PRIME 서비스 소개서 다운';
  let tab = 'Industry Download';
  let emailSubject = ' [ PRIME 서비스 소개서 다운 ]';
  let emailFooter = '- PRIME 서비스 소개서 다운 -';

  let pdfLocation =
    'https://s3.ap-northeast-2.amazonaws.com/thingplus.resource/etc/brochure/Leafet_Thingplus_PRIME_Service_Kor.pdf';
  let fileName = 'Leafet_Thingplus_PRIME_Service_Kor';
  if (curLng === 'ENG') {
    pdfLocation =
      'https://s3.ap-northeast-2.amazonaws.com/thingplus.resource/etc/brochure/Service_Brief_Thingplus_PRIME_Service_Eng.pdf';
    country = '영어';
    fileName = 'Service_Brief_Thingplus_PRIME_Service_Eng';
  }
  if (curLng === 'JPN') {
    pdfLocation =
      'https://s3.ap-northeast-2.amazonaws.com/thingplus.resource/etc/brochure/Leafet_Thingplus_PRIME_Service_Jpn.pdf';
    country = '일본어';
    fileName = 'Leafet_Thingplus_PRIME_Service_Jpn';
  }

  let company: MutableRefObject<string> = useRef('');
  let name: MutableRefObject<string> = useRef('');
  let position: MutableRefObject<string> = useRef('');
  let phone: MutableRefObject<string> = useRef('');
  let email: MutableRefObject<string> = useRef('');
  let check: MutableRefObject<boolean> = useRef(false);

  let [alertCompany, setAlertCompany] = useState(false);
  let [alertName, setAlertName] = useState(false);
  let [alertPhone, setAlertPhone] = useState(false);
  let [alertEmail, setAlertEmail] = useState(false);
  let [alertCheck, setAlertCheck] = useState(false);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.id == 'company') {
      company.current = e.target.value;

      if (e.target.value == '' || e.target.value == undefined) {
        setAlertCompany(true);
      } else {
        setAlertCompany(false);
      }
    } else if (e.target.id == 'name') {
      name.current = e.target.value;
      if (e.target.value == '' || e.target.value == undefined) {
        setAlertName(true);
      } else {
        setAlertName(false);
      }
    } else if (e.target.id == 'position') {
      position.current = e.target.value;
    } else if (e.target.id == 'phone') {
      phone.current = e.target.value;
      if (e.target.value == '' || e.target.value == undefined) {
        setAlertPhone(true);
      } else {
        setAlertPhone(false);
      }
    } else if (e.target.id == 'email') {
      email.current = e.target.value;
      let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

      if (!regex.test(email.current)) {
        setAlertEmail(true);
      } else {
        setAlertEmail(false);
      }
    } else if (e.target.id == 'check') {
      check.current = e.target.checked;

      if (!e.target.checked) {
        setAlertCheck(true);
      } else {
        setAlertCheck(false);
      }
    }
  }

  function handleSubmit() {
    let complete = true;
    let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-z]{2,6}$/;

    if (company.current == '' || company.current == undefined) {
      setAlertCompany(true);
      complete = false;
    }
    if (name.current == '' || name.current == undefined) {
      setAlertName(true);
      complete = false;
    }
    if (phone.current == '' || phone.current == undefined) {
      setAlertPhone(true);
      complete = false;
    }

    if (!regex.test(email.current)) {
      setAlertEmail(true);
      complete = false;
    }
    if (!check.current) {
      setAlertCheck(true);
      complete = false;
    }

    if (complete) {
      setBrochurePopup(false);
      downloadBrochure();
      sendRequest({
        country: country,
        category: category,
        company: company.current,
        name: name.current,
        position: position.current,
        phone: phone.current,
        email: email.current,
        tab,
        emailSubject,
        emailFooter,
      });
    } else {
      setBrochurePopup(true);
    }
  }

  function downloadBrochure() {
    fetch(pdfLocation, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let anchor = document.createElement('a');
        anchor.setAttribute('href', url);
        anchor.setAttribute('download', fileName);
        document.body.appendChild(anchor);
        anchor.click();
        if (anchor.parentNode) anchor.parentNode.removeChild(anchor);
      });
  }

  async function sendRequest(obj: object) {
    const response = await fetch('https://ruyvdtlqki.execute-api.ap-northeast-2.amazonaws.com/contact', {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'content-Type': 'application/json',
      },
    });
    const data = await response.json();
    console.log(data);
  }

  return (
    <div className="brochure-popup">
      <div className="content-box">
        <img
          className="close-btn"
          src={icon1}
          onClick={() => {
            setBrochurePopup(false);
          }}
        />
        <div className="left-section">
          <img className="image" src={bg1} />
        </div>
        <div className="right-section">
          <div className="top-section">
            <div className="big-text">{t('popup.brochure.title-text-0')}</div>
            <div className="middle-text">{t('popup.brochure.title-text-1')}</div>
          </div>
          <div className="bottom-section">
            <div className="category-box">
              <input
                id="company"
                type="string"
                placeholder={t('popup.brochure.input-text-0')}
                onChange={handleChange}
              ></input>
              {alertCompany && <div className="alert-text">{t('popup.brochure.alert-text-0')}</div>}
              <input
                id="name"
                type="string"
                placeholder={t('popup.brochure.input-text-1')}
                onChange={handleChange}
              ></input>
              {alertName && <div className="alert-text">{t('popup.brochure.alert-text-0')}</div>}
              <input
                id="position"
                type="string"
                placeholder={t('popup.brochure.input-text-2')}
                onChange={handleChange}
              ></input>
              <input
                id="phone"
                type="string"
                placeholder={t('popup.brochure.input-text-3')}
                onChange={handleChange}
              ></input>
              {alertPhone && <div className="alert-text">{t('popup.brochure.alert-text-0')}</div>}
              <input
                id="email"
                type="string"
                placeholder={t('popup.brochure.input-text-4')}
                onChange={handleChange}
              ></input>
              {alertEmail && <div className="alert-text">{t('popup.brochure.alert-text-2')}</div>}
            </div>
            <div className="check-box-container">
              <div className="check-box">
                <input id="check" type="checkbox" onChange={handleChange}></input>
                <div className="small-text">{t('popup.brochure.input-text-5')}</div>
              </div>
              <div
                className="lined-text"
                onClick={() => {
                  setPrivatePopup(true);
                }}
              >
                {t('popup.brochure.input-text-6')}
              </div>
            </div>
            {alertCheck && <div className="alert-text">{t('popup.brochure.alert-text-0')}</div>}
            <div className="submit-btn" onClick={handleSubmit}>
              {t('popup.brochure.btn-text-0')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PrivatePopup = ({ setPrivatePopup }: { setPrivatePopup: Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useTranslation();

  return (
    <div className="private-popup">
      <div className="content-box">
        <img
          className="close-btn"
          src={icon1}
          onClick={() => {
            setPrivatePopup(false);
          }}
        />
        <div className="top-section">
          <div className="big-text">{t('popup.private.title-text-0')}</div>
        </div>
        <div className="bottom-section">
          <div className="small-text">{t('popup.private.text-0')}</div>
          <div className="big-text">{t('popup.private.text-1')}</div>
          <div className="small-text">{t('popup.private.text-2')}</div>
          <div className="big-text">{t('popup.private.text-3')}</div>
          <div className="small-text">{t('popup.private.text-4')}</div>
          <div className="big-text">{t('popup.private.text-5')}</div>
          <div className="small-text">{t('popup.private.text-6')}</div>
          <div className="big-text">{t('popup.private.text-7')}</div>
          <div className="small-text">{t('popup.private.text-8')}</div>
          <div className="big-text">{t('popup.private.text-9')}</div>
          <div className="small-text">{t('popup.private.text-10')}</div>
          <div className="big-text">{t('popup.private.text-11')}</div>
          <div className="small-text">{t('popup.private.text-12')}</div>
          <div className="big-text">{t('popup.private.text-13')}</div>
          <div className="small-text">{t('popup.private.text-14')}</div>
          <div className="big-text">{t('popup.private.text-15')}</div>
          <div className="small-text">{t('popup.private.text-16')}</div>
          <div className="small-text">{t('popup.private.text-17')}</div>
          <div className="big-text">{t('popup.private.text-18')}</div>
          <div className="small-text">{t('popup.private.text-19')}</div>
          <div className="big-text">{t('popup.private.text-20')}</div>
          <div className="small-text">
            {t('popup.private.text-21')}
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
